import React, { useState } from 'react';
import { Download } from 'lucide-react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './DownloadButton.css';

const DownloadButton = ({ image, title, widgetId }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  // Download widget image as PNG file
  const downloadAsPNG = () => {
    const link = document.createElement('a');
    link.href = image;
    link.download = `${title.replace(/\s+/g, '_')}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowDropdown(false);
  };

  // Download widget content as PDF file 
  const downloadAsPDF = async () => {
    const widgetElement = document.getElementById(`widget-${widgetId}`);
    
    // Convert widget to canvas
    const canvas = await html2canvas(widgetElement, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff'
    });
    
    // Convert canvas to image
    const imgData = canvas.toDataURL('image/png');
    
    // Create PDF file
    const pdf = new jsPDF({
      orientation: canvas.width > canvas.height ? 'landscape' : 'portrait',
      unit: 'mm',
    });
    
    // Calculate dimensions to fit image within PDF page
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    
    // Center the image horizontally on the page
    const imgX = (pdfWidth - imgWidth * ratio) / 2;
    const imgY = 10; 
    
    // Add image to PDF
    pdf.addImage(
      imgData, 
      'PNG', 
      imgX, 
      imgY, 
      imgWidth * ratio, 
      imgHeight * ratio
    );
    
    // Download the PDF file
    pdf.save(`${title.replace(/\s+/g, '_')}.pdf`);
    
    setShowDropdown(false);
  };

  // Don't render button if no image is available
  if (!image) return null;

  return (
    <div className="download-button-container">
      <button 
        className="download-button"
        onClick={() => setShowDropdown(!showDropdown)}
        title="Download"
      >
        <Download size={18} />
      </button>
      {/* Dropdown menu with download options */}
      {showDropdown && (
        <>
          {/* Close dropdown when clicking outside */}
          <div 
            className="download-overlay" 
            onClick={() => setShowDropdown(false)}
          />
          <div className="download-dropdown">
            <button 
              className="download-option"
              onClick={downloadAsPNG}
            >
              Download as PNG
            </button>
            <button 
              className="download-option"
              onClick={downloadAsPDF}
            >
              Download as PDF
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default DownloadButton;